import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight } from "lucide-react";
import { fileUrl } from "../../lib/api";

export function ArtistCard({ artist, index = 0, styleMap = {} }) {
  return (
    <article data-testid={`artist-card-${artist.slug}`} className="group relative border border-ash overflow-hidden bg-charcoal">
      <Link to={`/artists/${artist.slug}`} className="mono-hover img-zoom block relative aspect-[3/4] overflow-hidden">
        <img src={fileUrl(artist.photo)} alt={`${artist.name} — tattoo artist`} loading={index < 6 ? "eager" : "lazy"} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/45 to-transparent" />
      </Link>

      <div className="absolute top-3 left-3 flex items-center gap-2 pointer-events-none">
        <span className="font-mono text-[0.6rem] text-white/60 tabular-nums">/{String(index + 1).padStart(2, "0")}</span>
        <span className="eyebrow">{artist.role}</span>
      </div>

      <div className="absolute inset-x-0 bottom-0 p-4 lg:p-5">
        <Link to={`/artists/${artist.slug}`}>
          <h3 className="display text-3xl lg:text-4xl text-white leading-none">{artist.name}</h3>
        </Link>
        <p className="mt-1.5 text-[#B4B4BE] font-mono text-[0.6rem] uppercase tracking-widest">{artist.experience}</p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {artist.styles?.slice(0, 3).map((s) => (
            <span key={s} className="text-[0.58rem] font-mono uppercase tracking-widest border border-white/15 bg-obsidian/40 backdrop-blur text-[#D4D4DC] px-2 py-0.5">
              {styleMap[s] || s}
            </span>
          ))}
        </div>

        <div className="mt-4 flex items-center gap-2">
          <Link to={`/artists/${artist.slug}`} data-testid={`view-artist-${artist.slug}`} className="flex-1 text-center font-mono text-[0.62rem] uppercase tracking-[0.16em] border border-white/25 bg-obsidian/40 backdrop-blur text-white py-2.5 hover:border-white transition-colors">
            View
          </Link>
          <Link to={`/booking?artist=${artist.slug}`} data-testid={`book-artist-${artist.slug}`} className="flex-1 text-center font-mono text-[0.62rem] uppercase tracking-[0.16em] bg-violet text-obsidian py-2.5 hover:bg-white transition-colors inline-flex items-center justify-center gap-1">
            Book <ArrowUpRight size={12} />
          </Link>
          {artist.instagram && (
            <a href={`https://instagram.com/${artist.instagram}`} target="_blank" rel="noreferrer" data-testid={`artist-instagram-${artist.slug}`} className="border border-white/25 bg-obsidian/40 backdrop-blur text-white p-2.5 hover:text-violet hover:border-violet transition-colors">
              <Instagram size={13} />
            </a>
          )}
        </div>
      </div>
    </article>
  );
}
